function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingMer from "@/utils/settingMer";
import XLSX from 'xlsx';
import { orderListDataApi, orderStatusNumApi, writeUpdateApi, orderListApi, updatePriceApi, orderLogApi, orderMarkApi, orderDeleteApi, orderRefuseApi, orderRefundApi, printSalesOrderLocal, tagPrintStatus as _tagPrintStatus, orderRefundInfo, getProductData } from '@/api/order';
import cardsData from '@/components/cards/index';
import zbParser from '@/components/FormGenerator/components/parser/ZBParser';
import detailsFrom from './orderDetail';
import orderSend from './orderSend';
import updateExpressNum from './updateExpressNum';
import orderVideoSend from './orderVideoSend';
import { storeStaffListApi } from '@/api/storePoint';
import Cookies from 'js-cookie';
import { isWriteOff } from "@/utils";
import { orderExcelApi } from '@/api/store';
import { checkPermi } from "@/utils/permission"; // 权限判断函数
import { customConfig } from '@/api/systemConfig';
export default {
  name: 'orderlistDetails',
  components: {
    cardsData: cardsData,
    zbParser: zbParser,
    detailsFrom: detailsFrom,
    orderSend: orderSend,
    orderVideoSend: orderVideoSend,
    updateExpressNum: updateExpressNum
  },
  props: {
    bizType: {
      default: 1,
      type: Number
    }
  },
  data: function data() {
    return {
      RefuseVisible: false,
      RefuseData: {},
      orderId: '',
      refundVisible: false,
      isBackendAdminApply: false,
      refundData: {},
      refundOrderInfo: {},
      dialogVisibleJI: false,
      shucaipifaDialogVisible: false,
      totalProfit: 0,
      purchaseConfig: {
        multiplier: 1.2,
        // 进货倍率：销售数量 * 1.2（保证下次进货充足，可按需修改）
        minNum: 20,
        // 最低进货量：即使销量为0，也建议进货20斤（避免断货）
        maxNum: 500 // 最高进货量：避免进货过多积压
      },
      saleInfo: '',
      purchaseInfo: [],
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        page: 1,
        limit: 10,
        type: 0
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: 'all',
        text: '全部'
      }, {
        value: 'info',
        text: '普通'
      }, {
        value: 'pintuan',
        text: '拼团'
      }, {
        value: 'bragin',
        text: '砍价'
      }, {
        value: 'miaosha',
        text: '秒杀'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: isWriteOff(),
      proType: 0,
      active: false,
      myCustomConfig: {},
      configReady: false,
      batchPrintLoading: false
    };
  },
  computed: {
    canPrintOrder: function canPrintOrder() {
      return ['shucaipifa'].includes(this.myCustomConfig.tenantKey);
    },
    tableKey: function tableKey() {
      return "".concat(this.myCustomConfig.tenantKey || '', "_").concat(this.myCustomConfig.mallType || '', "_").concat(this.canPrintOrder ? 1 : 0);
    }
  },
  created: function created() {
    var _this = this;
    customConfig().then(function (res) {
      _this.myCustomConfig = res;
      _this.configReady = true;
    });
  },
  mounted: function mounted() {
    this.getList();
    this.getOrderStatusNum();
    // this.getOrderListData();
  },
  methods: {
    tagPrintStatus: function tagPrintStatus(data) {
      var _this2 = this;
      _tagPrintStatus(data.orderNo).then(function (res) {
        _this2.$modal.msgSuccess('标记成功');
        _this2.getList();
      }).catch(function (error) {
        _this2.$modal.msgError(error.message);
      });
    },
    parseLayout: function parseLayout(v) {
      var layoutMap = {
        1: '不缩印',
        2: '二页合一',
        4: '四页合一'
      };
      return layoutMap[v] || '默认';
    },
    // 从extData中获取文件名
    getFileName: function getFileName(extData) {
      try {
        var data = JSON.parse(extData);
        return data.fileName || '未知文件';
      } catch (e) {
        return '未知文件';
      }
    },
    // 从extData中获取装订信息
    getWrapperName: function getWrapperName(extData) {
      try {
        var data = JSON.parse(extData);
        var wrapperInfo = JSON.parse(data.wrapperInfo || '{"info":{"storeName":""},"config":{"suk":"默认"}}');
        var storeName = wrapperInfo.info.storeName.split(" ")[0] || '不装订';
        var suk = wrapperInfo.config.suk || '默认';
        return "".concat(storeName, " ").concat(suk);
      } catch (e) {
        return '不装订 默认';
      }
    },
    // 从extData中获取自定义配置（背景图、缩印等）
    getCustomInfo: function getCustomInfo(extData) {
      try {
        var data = JSON.parse(extData);
        return JSON.parse(data.customInfo || '{}');
      } catch (e) {
        return {};
      }
    },
    // 从extData中获取资源总页数
    getResourcePageCount: function getResourcePageCount(extData) {
      try {
        var data = JSON.parse(extData);
        return data.resourcePageCount || 0;
      } catch (e) {
        return 0;
      }
    },
    // 下载订单文件
    handleDownload: function handleDownload(productList, username, orderId) {
      var _this3 = this;
      // 遍历商品列表（支持多文件下载，单个商品兼容）
      productList.forEach(function (item) {
        try {
          // 解析extData获取文件信息（容错处理）
          var _extData = JSON.parse(item.info.extData || '{}');
          var fileUrl = _extData.pdfFileUrl || _extData.fileUrl; // 优先PDF地址
          var originalFileName = _extData.fileName || "\u8BA2\u5355".concat(orderId, "_\u6587\u4EF6.pdf");

          // 1. 构造中文下载文件名（格式：订单ID_用户名_商品名称_原文件名）
          // 注意：保留原文件后缀，避免下载后格式错误
          var productName = item.info.productName || '未知商品';
          var userName = username || '未知用户';
          // 直接拼接中文（后续通过blob处理编码，无需提前encode）
          var downloadFileName = "".concat(orderId, "_").concat(userName, "_").concat(productName, "_").concat(originalFileName);

          // 校验文件地址
          if (!fileUrl) {
            _this3.$message.warning("\u6587\u4EF6\u5730\u5740\u4E0D\u5B58\u5728\uFF0C\u65E0\u6CD5\u4E0B\u8F7D\uFF1A".concat(originalFileName));
            return;
          }

          // 2. 核心逻辑：通过Blob+URL.createObjectURL实现强制下载（禁止预览）
          // 原理：将文件流转为Blob，再创建下载链接，浏览器会识别为"待下载文件"而非"可预览资源"
          fetch(fileUrl, {
            method: 'GET',
            // 跨域文件需后端配合设置Access-Control-Allow-Origin，否则需代理
            mode: 'cors',
            cache: 'no-cache'
          }).then(function (response) {
            if (!response.ok) throw new Error("\u8BF7\u6C42\u5931\u8D25\uFF1A".concat(response.status));
            // 转为Blob（保留原文件MIME类型，确保文件格式正确）
            return response.blob();
          }).then(function (blob) {
            // 创建临时下载链接
            var downloadUrl = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = downloadUrl;
            // 3. 中文文件名处理：使用decodeURIComponent包裹（兼容主流浏览器）
            // 原因：a标签download属性对中文直接编码会乱码，需先encode再decode
            link.download = decodeURIComponent(encodeURIComponent(downloadFileName));

            // 兼容处理
            link.rel = 'noopener noreferrer';
            link.style.display = 'none'; // 隐藏a标签

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 4. 清理资源（避免内存泄漏）
            setTimeout(function () {
              document.body.removeChild(link);
              URL.revokeObjectURL(downloadUrl); // 释放Blob URL
            }, 100);
            _this3.$message.success("\u5F00\u59CB\u4E0B\u8F7D\uFF1A".concat(downloadFileName));
          }).catch(function (error) {
            console.error('文件下载失败：', error);
            _this3.$message.error("\u4E0B\u8F7D\u5931\u8D25\uFF1A".concat(downloadFileName, "\uFF08").concat(error.message, "\uFF09"));
          });
        } catch (error) {
          console.error('下载参数解析失败：', error);
          var fileName = extData ? extData.fileName : '未知文件';
          _this3.$message.error("\u4E0B\u8F7D\u5931\u8D25\uFF1A".concat(fileName, "\uFF08\u53C2\u6570\u683C\u5F0F\u9519\u8BEF\uFF09"));
        }
      });
    },
    checkPermi: checkPermi,
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    // 核销订单
    onWriteOff: function onWriteOff(row) {
      var _this4 = this;
      this.$modalSure('核销订单吗').then(function () {
        writeUpdateApi(row.verifyCode).then(function () {
          _this4.$message.success('核销成功');
          _this4.tableFrom.page = 1;
          _this4.getList();
        });
      });
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 拒绝退款
    RefusehandleClose: function RefusehandleClose() {
      this.RefuseVisible = false;
    },
    onOrderRefuse: function onOrderRefuse(row) {
      this.orderids = row.orderNo;
      this.RefuseData = {
        orderId: row.orderNo,
        reason: ''
      };
      this.RefuseVisible = true;
    },
    RefusehandlerSubmit: function RefusehandlerSubmit(formValue) {
      var _this5 = this;
      orderRefuseApi({
        orderNo: this.orderids,
        reason: formValue.reason
      }).then(function (data) {
        _this5.$message.success('操作成功');
        _this5.RefuseVisible = false;
        _this5.getList();
      });
    },
    // 立即退款
    refundhandleClose: function refundhandleClose() {
      this.refundVisible = false;
    },
    onOrderRefund: function onOrderRefund(row, isBackendAdminApply) {
      var _this6 = this;
      this.isBackendAdminApply = isBackendAdminApply;
      var that = this;
      that.orderids = row.orderNo;
      if (that.bizType == 3) {
        orderRefundInfo({
          orderId: row.orderNo
        }).then(function (res) {
          that.refundOrderInfo = res;
          that.refundData = {
            orderId: row.orderNo,
            amount: res.refundPriceForLeaseBiz,
            type: '',
            remark: ''
          };
          _this6.refundVisible = true;
        });
      } else {
        that.refundData = {
          orderId: row.orderNo,
          amount: row.payAmount,
          type: '',
          remark: ''
        };
        this.refundVisible = true;
      }
    },
    refundhandlerSubmit: function refundhandlerSubmit(formValue) {
      var _this7 = this;
      orderRefundApi({
        amount: formValue.amount,
        orderNo: this.orderids,
        isBackendAdminApply: this.isBackendAdminApply
      }).then(function (data) {
        _this7.$message.success('操作成功');
        _this7.refundVisible = false;
        _this7.getList();
      });
    },
    // 发送
    sendOrder: function sendOrder(row) {
      if (row.orderType === 0) {
        this.$refs.send.modals = true;
        this.$refs.send.getList();
        // this.$refs.send.sheetInfo();
      } else {
        this.$refs.videoSend.modals = true;
        if (!JSON.parse(sessionStorage.getItem('videoExpress'))) this.$refs.videoSend.companyGetList();
      }
      this.orderId = row.orderNo;
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this8 = this;
      if (row.deleted) {
        this.$modalSure().then(function () {
          orderDeleteApi({
            orderNo: row.orderNo
          }).then(function () {
            _this8.$message.success('删除成功');
            _this8.tableData.data.splice(idx, 1);
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderId = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this9 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      orderLogApi(this.tableFromLog).then(function (res) {
        _this9.tableDataLog.data = res.recordList;
        _this9.tableDataLog.total = res.recordCount;
        _this9.LogLoading = false;
      }).catch(function () {
        _this9.LogLoading = false;
      });
    },
    // 导出方法（正常使用 XLSX 即可）
    exportDynamicProfitAndPurchase: function exportDynamicProfitAndPurchase() {
      console.log('run');
      try {
        var dataList = this.saleInfo || [];
        var _this$purchaseConfig = this.purchaseConfig,
          multiplier = _this$purchaseConfig.multiplier,
          minNum = _this$purchaseConfig.minNum,
          maxNum = _this$purchaseConfig.maxNum;
        if (dataList.length === 0) {
          this.$message.warning('暂无商品数据可导出');
          return;
        }

        // 导出前自动计算利润
        var total = 0;
        dataList.forEach(function (item) {
          var costPrice = Number(item.inputCost || 0);
          var unitPrice = Number(item.unit_price || 0);
          var salesNum = Number(item.sales_num || 0);
          if (!isNaN(costPrice) && costPrice >= 0) {
            item.profit = (unitPrice - costPrice) * salesNum;
            total += item.profit;
          }
        });
        this.totalProfit = total;

        // 组装导出数据
        var exportData = dataList.filter(function (item) {
          var costPrice = Number(item.inputCost || 0);
          var salesNum = Number(item.sales_num || 0);
          var unitPrice = Number(item.unit_price || 0);
          return !isNaN(costPrice) && costPrice >= 0 && unitPrice > 0;
        }).map(function (item) {
          var suggestPurchaseNum = Math.floor(Number(item.sales_num || 0) * multiplier);
          suggestPurchaseNum = Math.max(suggestPurchaseNum, minNum);
          suggestPurchaseNum = Math.min(suggestPurchaseNum, maxNum);
          var salesAmount = (Number(item.unit_price || 0) * Number(item.sales_num || 0)).toFixed(2);
          var costAmount = (Number(item.inputCost || 0) * Number(item.sales_num || 0)).toFixed(2);
          var profit = Number(item.profit || 0).toFixed(2);
          return {
            '商品ID': item.product_id || '无',
            '分类': item.category_name || '未分类',
            '商品名称': item.product_name || '未知商品',
            '销售单价(元)': Number(item.unit_price || 0).toFixed(2),
            '今日销售数量': Number(item.sales_num || 0).toFixed(0),
            '单位': item.unit_name || '斤',
            '成本单价(元)': Number(item.inputCost || 0).toFixed(2),
            '今日商品总利润(元)': profit,
            '今日商品总销售额(元)': salesAmount,
            '今日商品总成本(元)': costAmount,
            '建议进货斤数（按销量1.2倍）': suggestPurchaseNum
          };
        });
        if (exportData.length === 0) {
          this.$message.warning('暂无有效数据可导出（请先填写有效成本价并计算利润）');
          return;
        }

        // 新增汇总行
        var totalRow = {
          '商品ID': '-',
          '分类': '-',
          '商品名称': '今日汇总',
          '销售单价(元)': '-',
          '今日销售数量': '-',
          '单位': '-',
          '成本单价(元)': '-',
          '今日商品总利润(元)': this.totalProfit.toFixed(2),
          '今日商品总销售额(元)': exportData.reduce(function (sum, item) {
            return sum + Number(item['今日商品总销售额(元)']);
          }, 0).toFixed(2),
          '今日商品总成本(元)': exportData.reduce(function (sum, item) {
            return sum + Number(item['今日商品总成本(元)']);
          }, 0).toFixed(2),
          '建议进货斤数（按销量1.2倍）': '-'
        };
        exportData.push(totalRow);

        // 第二步：使用导入的 XLSX 生成 Excel（此时已不是 undefined，可正常访问 utils）
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(exportData);
        this.fitExportSheetColumns(ws, exportData);
        XLSX.utils.book_append_sheet(wb, ws, "今日利润统计&进货参考");
        var fileName = "\u5356\u83DC\u5546\u5BB6_\u5229\u6DA6&\u8FDB\u8D27\u53C2\u8003_".concat(new Date().toLocaleDateString().replace(/\//g, '-'), ".xlsx");
        XLSX.writeFile(wb, fileName);
        this.$message.success("\u5BFC\u51FA\u6210\u529F\uFF01\u5171\u5BFC\u51FA ".concat(exportData.length - 1, " \u4E2A\u6709\u6548\u5546\u54C1\uFF08\u542B1\u884C\u6C47\u603B\uFF09"));
      } catch (e) {
        console.error("导出失败：", e);
        this.$message.error('导出失败，请联系管理员');
      }
    },
    getExportCellWidth: function getExportCellWidth(value) {
      var str = value === null || value === undefined ? '' : String(value);
      var width = 0;
      for (var i = 0; i < str.length; i++) {
        width += str.charCodeAt(i) > 255 ? 2 : 1;
      }
      return width;
    },
    fitExportSheetColumns: function fitExportSheetColumns(ws, data) {
      var _this10 = this;
      if (!data || !data.length) return;
      var keys = Object.keys(data[0]);
      var colWidths = keys.map(function (key) {
        return _this10.getExportCellWidth(key);
      });
      data.forEach(function (row) {
        keys.forEach(function (key, index) {
          colWidths[index] = Math.max(colWidths[index], _this10.getExportCellWidth(row[key]));
        });
      });
      ws['!cols'] = colWidths.map(function (width) {
        return {
          wch: Math.min(width + 2, 60)
        };
      });
    },
    shucaipifalirunjisuan: function shucaipifalirunjisuan() {
      var _this11 = this;
      this.shucaipifaDialogVisible = true;
      // 仅调用这一个接口，获取所有需要的数据
      getProductData().then(function (res) {
        // 转为响应式数据，添加 inputCost 和 profit 字段
        _this11.saleInfo = res.map(function (item) {
          return Object.assign({}, item, {
            inputCost: Number(item.cost_price || 0),
            profit: 0
          });
        });
        // 初始化总利润
        _this11.totalProfit = 0;
        if (_this11.saleInfo.length === 0) {
          _this11.$message.info('今日暂无已售商品');
        }
      }).catch(function (e) {
        console.log(e);
        _this11.$message.error('数据获取失败，请联系管理员');
      });
    },
    // 计算总利润（核心方法）
    calculateTotalProfit: function calculateTotalProfit() {
      var _this12 = this;
      var total = 0;
      var dataList = this.saleInfo || [];
      if (dataList.length === 0) {
        this.$message.warning('暂无商品数据可计算');
        return;
      }

      // 遍历每个商品计算利润
      dataList.forEach(function (item) {
        // 校验输入的成本价
        var costPrice = Number(item.inputCost || 0);
        var unitPrice = Number(item.unit_price || 0);
        var salesNum = Number(item.sales_num || 0);
        if (isNaN(costPrice) || costPrice < 0) {
          _this12.$message.error("\u8BF7\u4E3A\u3010".concat(item.product_name || '未知商品', "\u3011\u8F93\u5165\u6709\u6548\u7684\u6210\u672C\u5355\u4EF7\uFF01"));
          return;
        }

        // 计算单个商品利润：(销售单价 - 成本单价) * 销量
        var profit = (unitPrice - costPrice) * salesNum;
        item.profit = profit;
        // 累加总利润
        total += profit;
      });

      // 更新总利润
      this.totalProfit = total;

      // 按钮视觉反馈（可选，模拟原有样式变化）
      var btn = document.querySelector('.el-dialog__footer .el-button--primary');
      if (btn) {
        btn.style.backgroundColor = '#4cd964';
        setTimeout(function () {
          btn.style.backgroundColor = ''; // 恢复Element UI默认样式
        }, 1000);
      }
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this13 = this;
      this.$prompt('订单备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入订单备注',
        inputType: 'textarea',
        inputValue: row.remark,
        inputPlaceholder: '请输入订单备注',
        inputValidator: function inputValidator(value) {
          if (!value) return '输入不能为空';
        }
      }).then(function (_ref) {
        var value = _ref.value;
        orderMarkApi({
          mark: value,
          orderNo: row.orderNo
        }).then(function () {
          _this13.$message.success('操作成功');
          _this13.getList();
        });
      }).catch(function () {
        _this13.$message.info('取消输入');
      });
    },
    onOrderExpressNum: function onOrderExpressNum(row) {
      console.log(row);
      this.$refs.updateExpressNum.modals = true;
      this.$refs.updateExpressNum.getList(row.deliveryName, row.deliveryId);
      this.orderId = row.orderNo;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 编辑
    edit: function edit(row) {
      this.orderId = row.orderNo;
      this.editData = {
        orderId: row.orderNo,
        totalPrice: row.totalPrice,
        totalPostage: row.totalPostage,
        payPrice: row.payAmount,
        payPostage: row.payPostage,
        gainIntegral: row.gainIntegral
      };
      this.dialogVisible = true;
    },
    handlerSubmit: function handlerSubmit(formValue) {
      var _this14 = this;
      var data = {
        orderNo: formValue.orderId,
        payAmount: formValue.payPrice
      };
      updatePriceApi(data).then(function (data) {
        _this14.$message.success('编辑数据成功');
        _this14.dialogVisible = false;
        _this14.getList();
      });
    },
    // 列表
    getList: function getList() {
      var _this15 = this;
      this.listLoading = true;
      this.tableFrom.bizType = this.bizType;
      orderListApi(this.tableFrom).then(function (res) {
        _this15.tableData.data = res.recordList || [];
        _this15.tableData.total = res.recordCount;
        _this15.listLoading = false;
        _this15.checkedCities = _this15.$cache.local.has('order_stroge') ? _this15.$cache.local.getJSON('order_stroge') : _this15.checkedCities;
      }).catch(function () {
        _this15.listLoading = false;
      });
    },
    // 数据统计
    getOrderListData: function getOrderListData() {
      var _this16 = this;
      orderListDataApi({
        dateLimit: this.tableFrom.dateLimit
      }).then(function (res) {
        _this16.cardLists = [{
          name: '订单数量',
          count: res.count,
          color: '#1890FF',
          class: 'one',
          icon: 'icondingdan'
        }, {
          name: '订单金额',
          count: res.amount,
          color: '#A277FF',
          class: 'two',
          icon: 'icondingdanjine'
        }, {
          name: '微信支付金额',
          count: res.weChatAmount,
          color: '#EF9C20',
          class: 'three',
          icon: 'iconweixinzhifujine'
        }, {
          name: '余额支付金额',
          count: res.yueAmount,
          color: '#1BBE6B',
          class: 'four',
          icon: 'iconyuezhifujine2'
        }];
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this17 = this;
      orderStatusNumApi({
        dateLimit: this.tableFrom.dateLimit,
        type: this.tableFrom.type
      }).then(function (res) {
        _this17.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      orderExcelApi(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    //打印小票
    onOrderPrint: function onOrderPrint(order) {
      var _this18 = this;
      printSalesOrderLocal(order).then(function () {
        _this18.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this18.$modal.msgError(error.message || '打印失败');
      });
    },
    onBatchOrderPrint: function () {
      var _onBatchOrderPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _iterator, _step, order;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.selectionList.length) {
                _context.next = 3;
                break;
              }
              this.$modal.msgWarning('请先选择订单');
              return _context.abrupt("return");
            case 3:
              this.batchPrintLoading = true;
              _context.prev = 4;
              _iterator = _createForOfIteratorHelper(this.selectionList);
              _context.prev = 6;
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context.next = 14;
                break;
              }
              order = _step.value;
              _context.next = 12;
              return printSalesOrderLocal(order);
            case 12:
              _context.next = 8;
              break;
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](6);
              _iterator.e(_context.t0);
            case 19:
              _context.prev = 19;
              _iterator.f();
              return _context.finish(19);
            case 22:
              this.$modal.msgSuccess('批量打印成功');
              _context.next = 28;
              break;
            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](4);
              this.$modal.msgError(_context.t1.message || '打印失败');
            case 28:
              _context.prev = 28;
              this.batchPrintLoading = false;
              return _context.finish(28);
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 25, 28, 31], [6, 16, 19, 22]]);
      }));
      function onBatchOrderPrint() {
        return _onBatchOrderPrint.apply(this, arguments);
      }
      return onBatchOrderPrint;
    }()
  }
};